const extractPoi = (poi) => {
  const {
    address: { city, street, streetExtra },
    location,
  } = poi;
  return {
    city,
    street,
    streetExtra,
    location,
  };
};
const extractAddress = (address) => {
  const {
    city, street, streetExtra, location,
  } = address;
  return {
    city,
    street,
    streetExtra,
    location,
  };
};

export default function getAddress(address) {
  return typeof address.poi === 'object' ? extractPoi(address.poi) : extractAddress(address);
}
